<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">

.my_modal {
    .ivu-modal-body{
        padding: 0;
        width: 800px;
    }
    .ivu-modal-content{
        background-color: rgba(0,0,0,0);
    }
    .ivu-modal{
        width: 800px !important;
        top: 0;
    }
    .ivu-modal-wrap{
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue